import { ASSET_PATHS } from '../../utils/assetPath';

interface EyeIconProps {
  /**
   * Additional CSS class names
   */
  className?: string;
  /**
   * Size of the icon in pixels
   */
  size?: number;
  /**
   * Aria label for accessibility
   */
  ariaLabel?: string;
}

/**
 * EyeIcon component
 *
 * Displays an eye icon for visibility toggle (show content).
 *
 * @example
 * <EyeIcon />
 * <EyeIcon size={20} ariaLabel="Show password" />
 */
function EyeIcon({ className = '', size = 20, ariaLabel = 'Show' }: EyeIconProps) {
  return (
    <img
      alt=''
      aria-label={ariaLabel}
      className={`eye-icon ${className}`}
      height={size}
      src={ASSET_PATHS.EYE_ICON}
      width={size}
    />
  );
}

export default EyeIcon;
